import React, { Component } from 'react';
import { TweenMax } from 'gsap';
import PlyrComponent from '../global/PlyrComponent';
import ScreenedImageCover from '../ui/ScreenedImageCover';

import BackToChapterButton from './BackToChapterButton';
import PlayPauseButton from '../ui/PlayPauseButton';

import style from './ChapterSectionVideo.module.scss';

class ChapterSectionVideo extends Component {
  componentDidMount() {
    if (this.props.setActiveImage) {
      this.props.setActiveImage(
        this.props.index,
        this.props.sectionData.image.sizes.large
      );
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.preExit !== nextProps.preExit && nextProps.preExit) {
      this.preDrawExit();
    }
    if (
      this.props.exitingDrawn !== nextProps.exitingDrawn &&
      nextProps.exitingDrawn
    ) {
      this.postDrawExit();
    }
  }
  preDrawExit() {
    if (this.props.isVideoOpen) {
      this.onVideoClose();
    }
    TweenLite.to(this.contentEl, 0.5, {
      opacity: 0,
    });
  }
  postDrawExit() {
    this.bk.style.visibility = 'hidden';
    // TweenLite.set(this.bk, { opacity: 0 });
  }
  onVideoOpen = () => {
    this.props.setVideoOpen(true);

    TweenMax.to('.back-to-chapter', 0.8, {
      opacity: 1,
      ease: Circ.easeInOut,
      delay: 0.3,
    });

    // hide header on mobile
    if (window.innerWidth < 768) {
      TweenLite.to('.site-header', 0.8, {
        opacity: 0,
        ease: Circ.easeInOut,
      });
      const header = document.querySelector('.site-header');
      header.style.pointerEvents = 'none';
      const dropdown = document.querySelectorAll('.js-dropdownNav');
      if (dropdown) {
        dropdown.forEach(dd => {
          dd.style.pointerEvents = 'none';
        });
      }
    }

    TweenMax.to('.js-nextSectionArrow', 0.8, {
      opacity: 0,
      ease: Circ.easeInOut,
    });
  };

  onVideoClose = () => {
    this.props.setVideoOpen(false);

    TweenMax.to('.back-to-chapter', 0.8, {
      opacity: 0,
      ease: Circ.easeInOut,
      delay: 0.3,
    });

    // hide header on mobile
    if (window.innerWidth < 768) {
      TweenLite.to('.site-header', 0.8, {
        opacity: 1,
        ease: Circ.easeInOut,
      });
      const header = document.querySelector('.site-header');
      header.style.pointerEvents = 'auto';
      const dropdown = document.querySelectorAll('.js-dropdownNav');
      if (dropdown) {
        dropdown.forEach(dd => {
          dd.style.pointerEvents = 'auto';
        });
      }
    }

    TweenMax.to('.js-nextSectionArrow', 0.8, {
      opacity: 1,
      ease: Circ.easeInOut,
    });
  };

  plyrOptions = {
    controls: [
      'play',
      'progress',
      'current-time',
      'mute',
      'volume',
      'captions',
      'settings',
      'fullscreen',
    ],
  };
  hasVideo() {
    return (
      this.props.sectionData.video_file.url ||
      this.props.sectionData.youtube_id ||
      this.props.sectionData.vimeo_id
    );
  }
  render() {
    return (
      <div
        className={`section ${style.sectionWrapper}`}
        ref={el => {
          this.bk = el;
        }}
      >
        {this.props.isChapter && (
          <BackToChapterButton
            isVideoOpen={this.props.isVideoOpen}
            onVideoClose={this.onVideoClose}
          />
        )}

        <div
          className={`${style.videoIntroWrapper} ${
            this.props.isVideoOpen ? style.videoIntroHidden : ''
          }`}
        >
          {this.props.sectionData.image && (
            <div className={style.videoPoster}>
              <ScreenedImageCover
                url={this.props.sectionData.image.sizes.large}
                load={this.props.display}
              />
            </div>
          )}
          <div
            ref={el => {
              this.contentEl = el;
            }}
          >
            <div
              className={style.videoIntro}
              style={{
                pointerEvents: this.props.isVideoOpen ? 'none' : 'auto',
              }}
            >
              {this.props.sectionData.title && (
                <div className={style.videoTitleWrapper}>
                  <div className={`splitText ${style.videoTitle}`}>
                    {this.props.sectionData.title}
                  </div>
                </div>
              )}
              {this.props.sectionData.subtitle && (
                <div className={style.videoDescription}>
                  {this.props.sectionData.subtitle}
                </div>
              )}

              {this.hasVideo() && (
                <div
                  className={style.playButton}
                  onClick={this.onVideoOpen}
                  onTouchStart={this.props.disallowScroll}
                  onTouchEnd={this.props.allowScroll}
                >
                  <PlayPauseButton noBorder isVideoPaused largeButton />
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className={`chapter-video ${style.videoWrapper} ${
            this.props.isVideoOpen ? style.videoOpen : ''
          }`}
        >
          {this.hasVideo() && (
            <PlyrComponent
              isChapter
              options={this.plyrOptions}
              videoData={this.props.sectionData}
              isVideoOpen={this.props.isVideoOpen}
            />
          )}
        </div>
      </div>
    );
  }
}

export default ChapterSectionVideo;



// WEBPACK FOOTER //
// ./src/components/chapter/ChapterSectionVideo.js